package pl.mothdigital.neuronowi.common.utils

import kotlinx.browser.*
import pl.mothdigital.neuronowi.common.resources.UrlResources

/**
 * Opens the Instagram profile in a new tab.
 * Modern browsers automatically apply 'noopener' to window.open() with '_blank' for security.
 */
fun openInstagramNeuronowi() {
    window.open(UrlResources.INSTAGRAM_NEURONOWI_URL, UrlResources.BLANK_TARGET)
}

/**
 * Opens the Facebook profile in a new tab.
 * Modern browsers automatically apply 'noopener' to window.open() with '_blank' for security.
 */
fun openFacebookNeuronowi() {
    window.open(UrlResources.FACEBOOK_NEURONOWI_URL, UrlResources.BLANK_TARGET)
}
